import { useState } from "react";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticlesSection() {
  const [showAll, setShowAll] = useState(false);
  const displayed = showAll ? articles : articles.slice(0, 12);

  return (
    <section id="articles" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-amber-100 text-amber-700 text-xs font-semibold rounded-full uppercase tracking-wider mb-3">SEO Articles</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            ACBuy Spreadsheet 2026 Guides
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-sm md:text-base">
            In-depth guides on hipobuy spreadsheet, hipobuy shipping coupons, QC finder, haul tips and more.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {displayed.map((article) => (
            <Link
              key={article.id}
              to={`/articles/${article.slug}`}
              className="group bg-white border border-gray-100 rounded-lg overflow-hidden hover:border-amber-300 transition-all duration-200 cursor-pointer flex flex-col"
            >
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xs text-amber-600 font-medium bg-amber-50 px-2 py-0.5 rounded-full">{article.readTime}</span>
                  <span className="text-xs text-gray-400">{article.date}</span>
                </div>
                <h3 className="text-sm font-bold text-gray-800 group-hover:text-amber-600 transition-colors leading-snug mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-gray-500 leading-relaxed line-clamp-3 flex-1">{article.excerpt}</p>
                <div className="mt-3 flex items-center gap-1 text-amber-500 text-xs font-semibold">
                  Read More <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {!showAll && articles.length > 12 && (
          <div className="text-center mt-10">
            <button
              onClick={() => setShowAll(true)}
              className="px-8 py-3 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              View All {articles.length} Articles
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
